import React from 'react';
import { ArrowRight } from 'lucide-react';
import { partners } from '../data/mock';
import { useT } from '../i18n/LanguageContext';

const LogoCard = ({ p }) => (
  <div className="shrink-0 w-40 md:w-48 h-24 md:h-28 rounded-2xl border border-slate-200 bg-white flex items-center justify-center px-5 py-3 mx-2 hover:shadow-md hover:border-[#0b3b8c]/30 transition-all">
    <img
      src={p.logo}
      alt={p.name}
      loading="lazy"
      className="max-h-full max-w-full object-contain"
    />
  </div>
);

const Projects = () => {
  const { t } = useT();

  const row1 = partners.slice(0, 14);
  const row2 = partners.slice(14);

  return (
    <section id="projects" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="flex flex-wrap items-end justify-between gap-6">

          <div>

            {/* Badge */}
            <span className="inline-block px-3 py-1 rounded-full border border-slate-200 bg-slate-50 text-slate-600 text-[11px] tracking-[0.25em] font-semibold">
              {t.projectsSection.badge}
            </span>

            {/* Title */}
            <h2 className="mt-6 text-4xl md:text-5xl font-black text-[#0b1c3a] leading-[1.05] tracking-tight">
              {t.projectsSection.titleA}{' '}
              <span className="italic font-serif text-[#0b3b8c]">
                {t.projectsSection.titleAccent}
              </span>
            </h2>

            {/* Description */}
            <p className="mt-3 text-slate-600 max-w-xl">
              {t.projectsSection.subtitle}
            </p>

          </div>

          {/* Top link */}
          <a
            href="/references"
            className="inline-flex items-center gap-2 text-[#0b1c3a] font-semibold text-sm hover:text-[#0b3b8c] transition-colors"
          >
            {t.projectsSection.viewAll}
            <ArrowRight className="w-4 h-4" />
          </a>

        </div>
      </div>

      {/* Marquee row 1 */}
      <div className="relative mt-14">
        <div className="marquee flex">

          <div className="marquee-track flex">
            {row1.map((p, i) => (
              <LogoCard key={`a-${i}`} p={p} />
            ))}
          </div>

          <div className="marquee-track flex" aria-hidden="true">
            {row1.map((p, i) => (
              <LogoCard key={`b-${i}`} p={p} />
            ))}
          </div>

        </div>
      </div>

      {/* Marquee row 2 */}
      <div className="relative mt-4">
        <div className="marquee marquee-reverse flex">

          <div className="marquee-track flex">
            {row2.map((p, i) => (
              <LogoCard key={`c-${i}`} p={p} />
            ))}
          </div>

          <div className="marquee-track flex" aria-hidden="true">
            {row2.map((p, i) => (
              <LogoCard key={`d-${i}`} p={p} />
            ))}
          </div>

        </div>
      </div>

      {/* Bottom button */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mt-16 flex justify-center">

          <a
            href="/references"
            className="px-6 py-3 rounded-full border border-slate-300 text-[#0b1c3a] font-semibold text-sm hover:bg-[#0b3b8c] hover:text-white hover:border-[#0b3b8c] transition-colors inline-flex items-center gap-2"
          >
            {t.projectsSection.discover}
            <ArrowRight className="w-4 h-4" />
          </a>

        </div>
      </div>

    </section>
  );
};

export default Projects;